import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { configure } from 'mobx';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';

import Routes from './routes/Routes';

configure({ enforceActions: 'never' });

const queryClient = new QueryClient();

const router = createBrowserRouter(Routes);

const App = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  );
};

export default App;
